import React, { PropsWithChildren, ReactNode, JSX } from 'react';
import {
  DropdownToggle,
  DropdownMenu,
  Dropdown,
  DropdownItem,
  DropdownItemProps
} from 'reactstrap';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface Props {
  isOpen: boolean;
  onDropdownToggle: Function;
  title?: ReactNode;
  caret?: boolean;
  icon?: IconDefinition;
  id?: string;
  right?: boolean;
  tabIndex?: number | null;
  disabled?: boolean;
  onToggleButtonClick?: () => void;
}

export const IsoDropdownItem = (props: PropsWithChildren<DropdownItemProps>): JSX.Element => {
  const { children, className } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <DropdownItem {...props} className={`dropdown-item ${className || ''}`}>
      {children}
    </DropdownItem>
  );
};

const IsoDropdown = (props: PropsWithChildren<Props>): JSX.Element => {
  const {
    id,
    children,
    icon,
    caret,
    title,
    onDropdownToggle,
    isOpen,
    right,
    disabled,
    onToggleButtonClick
  } = props;
  const tabIndex: number | undefined =
    props.tabIndex === null ? undefined : props.tabIndex === undefined ? 1 : props.tabIndex;
  return (
    <Dropdown
      id={id}
      className="iso__dropdown"
      isOpen={isOpen}
      toggle={(): void => onDropdownToggle(!isOpen)}
      tabIndex={tabIndex}
      disabled={disabled}
    >
      <DropdownToggle
        color="white"
        className="iso__dropdown__toggle"
        caret={caret}
        onClick={onToggleButtonClick}
        tabIndex={tabIndex}
      >
        <div className="d-flex">
          {icon && (
            <div className="ml-auto">
              <FontAwesomeIcon icon={icon} />
            </div>
          )}
          <div className="w-100 text-truncate">{title || ''}</div>
        </div>
      </DropdownToggle>
      {isOpen && (
        <DropdownMenu flip={false} right={right} persist={false}>
          {children}
        </DropdownMenu>
      )}
    </Dropdown>
  );
};
export default IsoDropdown;
